import { Injectable } from '@angular/core';
import { ProjectFinalizationInfoVO } from '../../../model/vo/project.vo';
import { ReportVO } from '../../../model/vo/report.vo';
import { LabelDuplicateVO } from '../../../model/vo/label-duplicate.vo';
import { AlertButton } from '@shared/alert/alertButton';
import { AlertHelper } from '@shared/alert/alert.helper';
import { ProjectModel } from '../../../model/project.model';
import { ProjectDataService } from '../../../service/project-data.service';
import { ProjectService } from './project.service';
import { SelectProjectReportService } from '../../report/service/select-project-report.service';

@Injectable({providedIn: 'root'})
export class ConfSettingsProjectService {

  constructor(private selectProjectReportService: SelectProjectReportService,
              private alertHelper: AlertHelper,
              private projectModel: ProjectModel,
              private projectDataService: ProjectDataService,
              private projectService: ProjectService) {
  }

  public finalizationSuccessHandler(projectFinalizationInfoVO: ProjectFinalizationInfoVO): void {
    if (!projectFinalizationInfoVO) {
      return;
    }

    if (projectFinalizationInfoVO.currentState === 'createExportPreview') {
      this.selectProjectReportService.openProjectReportPopup(ReportVO.TYPE_PDF, false, [], [], true, projectFinalizationInfoVO);
    } else if (projectFinalizationInfoVO.currentState === 'waitingOnDuplicateDecisionForExport') {
      let {duplicateArticleNumber, plant} = this.getDuplicatedArticleNumberAndPlant(projectFinalizationInfoVO);
      this.alertHelper
        .showAlert(
          'finalizeProject.title.duplicate_at_export_found',
          'finalizeProject.message.duplicate_at_export_found',
          {'0': duplicateArticleNumber, '1': plant},
          [AlertButton.YES, AlertButton.NO],
          ``
        )
        .then((answer) => {
          if (answer === AlertButton.YES) {
            this.executeFinalizeProjectForDuplicate(
              this.projectModel.currentProject.id,
              this.projectModel.currentProject.currentVersion,
              projectFinalizationInfoVO
            );
          }
        });
    } else if (projectFinalizationInfoVO.currentState === 'dublicateWithDifferentPlant') {
      let {duplicateArticleNumber, plant} = this.getDuplicatedArticleNumberAndPlant(projectFinalizationInfoVO);
      this.alertHelper.showAlert(
        'finalizeProject.title.duplicate_with_DifferentPlant',
        'finalizeProject.message.duplicate_with_DifferentPlant',
        {'0': duplicateArticleNumber, '1': plant},
        [AlertButton.OK],
        ``
      );
    } else if (projectFinalizationInfoVO.currentState === 'success') {
      this.projectService.updateProjectData(this.projectModel.currentProject.id, this.projectModel.currentProject.currentVersion);
      this.alertHelper.showAlert('finalizeProject.title.success', 'finalizeProject.message.success', null, [AlertButton.OK], "info");
    }
  }

  private getDuplicatedArticleNumberAndPlant(projectFinalizationInfoVO: ProjectFinalizationInfoVO): {duplicateArticleNumber: string, plant: string} {
    let duplicateArticleNumber: string = '';
    let plant: string = '';
    if (projectFinalizationInfoVO.duplicateArticleNumbers != null && projectFinalizationInfoVO.duplicateArticleNumbers.length > 0) {
      if ((projectFinalizationInfoVO.duplicateArticleNumbers[0] as LabelDuplicateVO) != null) {
        duplicateArticleNumber = (projectFinalizationInfoVO.duplicateArticleNumbers[0] as LabelDuplicateVO).articleNumber;
        plant = (projectFinalizationInfoVO.duplicateArticleNumbers[0] as LabelDuplicateVO).productionPlant;
      }
    }
    return {duplicateArticleNumber, plant};
  }

  public executeFinalizeProjectForDuplicate(projectId: number, version: number, projectFinalizationInfoVO: ProjectFinalizationInfoVO): void {
    this.projectDataService.executeFinalizeProjectForDuplicate(projectId, version, projectFinalizationInfoVO)
      .subscribe(
        (result: any) => {
          this.alertHelper.showAlert(
            'finalizeProject.title.success_for_duplicate',
            'finalizeProject.message.success_for_duplicate',
            null,
            [AlertButton.OK],
            ``
          );
          this.projectService.updateProjectData(projectId, version);
        },
        (error: any) => {
          this.projectService.updateProjectData(projectId, version);
          this.alertHelper.showError(
            'finalizeProject.title.error_finalizing_configuration',
            'finalizeProject.message.error_finalizing_configuration',
            {translationParams: [error]}
          );
        }
      );
  }
}
